import React, { useEffect } from 'react'
import useShop from '../context/AppContext'
import { Helmet } from 'react-helmet'
import { Layout } from '../layout'

import { ServiceHeroConvertingNewsletterDesign, ServiceContact, ServiceExpert, ServiceSetup } from '../container'

const ServicesConvertingNewsletterDesign = () => {
  const { appServiceId, appServiceSubject } = useShop()

  useEffect(() => {
    appServiceId('6')
    appServiceSubject('Converting Newsletter Design')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Layout>
      <Helmet>
        <title>Shopify Converting Newsletter Design – Robert Eberhard</title>
      </Helmet>
      <ServiceHeroConvertingNewsletterDesign />
      <ServiceContact />
      <ServiceExpert />
      <ServiceSetup />
    </Layout>
  )
}

export default ServicesConvertingNewsletterDesign
